import moment from 'moment';
/**
 * 判断是否是微信环境
 * @returns {boolean}
 */
export function getIsWxClient () {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    }
    return false;
}

// 计算相差多少天数
export function getDayGap(date) {
    let currentDate = new Date(moment().format('YYYY-MM-DD'));
    let gap = Math.abs(currentDate.getTime() - new Date(moment(date).format('YYYY-MM-DD')));
    let dayGap = Math.floor(gap / 1000 / 60 / 60 / 24);
    return dayGap;
}